import Swal from "sweetalert2";

const Toaster = (): typeof Swal => {
	const Toast = Swal.mixin({
		toast: true,
		position: "bottom-end",
		showConfirmButton: false,
		timer: 5000,
		showCloseButton: true,
		timerProgressBar: true,
		didOpen: (toast) => {
			toast.addEventListener("mouseenter", Swal.stopTimer);
			toast.addEventListener("mouseleave", Swal.resumeTimer);
		},
		customClass: {
			popup: "bring-to-top",
			container: "bring-to-top",
		},
	});

	return Toast;
};

export const toast = Toaster();

export default Toaster;
